import React from "react";
import "./Home.css";

const Home = () => {
  return (
    <>
      <div className="container" id="home">
        <h1 className="title">
          YOUR FINANCIAL{" "}
          <span className="color-change">PROFESSIONAL & INSURANCE</span> ADVISOR
        </h1>
      </div>
      {/* YouTube Video Embed */}
      <div className="video-container">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/eBxjBP0vY18?si=Vv_ONcuvduJ1h-0W"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
    </>
  );
};

export default Home;
